import { Link } from "react-router-dom";
import "./footer.scss";

const Footer: React.FC = () => {
    return (
        <>
            <div className="footer contain-wrapper">
                <footer className="contain">
                    <div className="logo-wrapper">
                        <img src="/ui/logo.svg" alt="logo" />
                    </div>
                    <div className="footer-content">
                        <div className="emails">
                            <a href="mailto:spaceindustrial@marchmont-im.com"  className="inline-copy">
                                <p>Email for enquires</p>
                                <div className="parallelogram-small"></div>
                            </a>
                            <div className="copy">
                                <p>Space Industrial</p>
                                <p>C/o Marchmont</p>
                                <p>3rd Floor, 46 Berners Street,</p>
                                <p>London, W1T 3NE</p>                                
                            </div>
                            <a href="tel:+442081425660">
                                <p>+44 (0) 208 142 5660</p>
                            </a>
                        </div>
                        <div className="links">
                            <Link target="_top" to="privacy-policy">
                                <p>Privacy Policy</p>
                            </Link>
                            <a href="">
                                <p>
                                    Misrepresentation Act: These particulars are
                                    believed to be correct at the date of
                                    publication, but their accuracy is in no way
                                    guaranteed, neither do they form part of any
                                    contract. All areas are approximate.
                                    December 2024.
                                </p>
                            </a>
                        </div>
                    </div>
                </footer>
            </div>
        </>
    );
};

export default Footer;
